import { PDF_STATUS_KEY } from '@messenger/consts'
import type { PdfState } from '@/hooks/pdf/usePdfViewer'

type UsePdfStateParams = {
  pdfState: PdfState
}

export const usePdfState = ({ pdfState }: UsePdfStateParams) => {
  const {
    generating,
    generatingText,
    pendingCloseOperation,
    generationState,
    showPdfViewer,
    disclaimerAcknowledged,
    previewCustomizeProductHeaderDropdownsDisabled,
    canCustomize,
    canRevertFinalization,
    isProof,
    shouldSetProductStatusToFinalized,
    shouldSetProductStatusToEditing,
    shouldSetProductStatusToProofSent,
    proofGalleryDetails,
  } = pdfState

  return {
    // Generation control state
    generating,
    generatingText,
    pendingCloseOperation,

    // PDF generation progress and result
    pdfGenerationProgress: generationState?.progress ?? 0,
    pdfGenerationStatus: generationState?.status ?? PDF_STATUS_KEY.IN_QUEUE,
    pdfUrl: generationState?.pdf ?? '',

    // Modal and UI visibility state
    showPdfViewer,
    disclaimerAcknowledged,

    // Button state and permissions
    previewCustomizeProductHeaderDropdownsDisabled,
    canCustomize,
    canRevertFinalization,
    isProof,

    // Deferred product status update flags
    shouldSetProductStatusToFinalized,
    shouldSetProductStatusToEditing,
    shouldSetProductStatusToProofSent,

    // Proof gallery metadata
    proofGalleryDetails,
  }
}
